"use strict";
/*
 * Created on 19. 9. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var ValidationResult_1 = require("../../core/model/errors/ValidationResult");

var utils_1 = require("../../core/utils");

var ProductPurchasePrice_1 = require("../../product/model/ProductPurchasePrice");

var RegularProductPrice_1 = require("../../product/model/RegularProductPrice");

var VendorAllowanceBonus_1 = require("../../vendor-allowance/model/VendorAllowanceBonus");

var AbstractReleaseItem_1 = require("./AbstractReleaseItem");

var PriceZoneReleasePrices_1 = require("./PriceZoneReleasePrices");

var RealImpactValue_1 = require("./RealImpactValue");
/**
 * Item re-priced during the release. This is entity with its own database collection.
 * Release item holds reference and optimal prices calculated for a product during the release.
 *
 * @author Radek Beran
 */


var ReleaseItem =
/*#__PURE__*/
function (_AbstractReleaseItem_) {
  _inherits(ReleaseItem, _AbstractReleaseItem_);

  /**
   * Creates new release item.
   * @param id identifier of release item
   * @param releaseId release id
   * @param productId re-priced product id
   * @param productExternalId external id of re-priced product
   * @param productName name of product
   * @param categoryIds list of product categories copied from associated product.
   *        The first one is lowest category, the last one is root.
   * @param exported release item is marked to be exported either with backend re-pricing (optimization) algorithm,
   *        or by the following user's manual correction (flags that new prices from this item will be exported)
   * @param exportedDate date of export (for already released item)
   * @param readonly readonly item that should not be re-priced or edited, it is present in release only for info and statistics
   * @param prices various prices of product that are valid inside individual price zones. The list contains elements only for zones
   *        in which the product is active.
   * @param purchasePrice purchase price (PP) without VAT (which does not have date-to), simple average in case of more suppliers
   * @param regularPrice Actual regular price (ARP) within national zone, if release is related to national zone, this value should be
   *        the same as {@link PriceZoneReleasePrices.regularPrice}.
   * @param vendorAllowance
   * @param productSensitivityId product sensitivity; LOG-548: Change in product's sensitivity
   *        should not influence already opened release, thus this
   *        field is authoritative product sensitivity within the release.
   * @param tierId tier assigned to product
   * @param weighted denotes that item with this flag is weighted (e.g. for transaction, sales and supply, respectively)
   * @param fixedPrice denotes that item with this flag is with fixed price that should not be changed within repricing
   * @param validationResult validation messages (alerts)
   * @param uploaded true if this is release item with uploaded price
   * @param realImpact various KPIs based on real sales
   */
  function ReleaseItem(id, releaseId, productId, productExternalId, productName, categoryIds, exported, exportedDate, readonly, prices, purchasePrice, regularPrice, vendorAllowance, productSensitivityId, tierId, weighted, fixedPrice, validationResult, uploaded, realImpact) {
    var _this;

    _classCallCheck(this, ReleaseItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseItem).call(this, id, releaseId, productId, productExternalId, productName, categoryIds, readonly, uploaded, exported, exportedDate, validationResult));
    _this.id = id;
    _this.releaseId = releaseId;
    _this.productId = productId;
    _this.productExternalId = productExternalId;
    _this.productName = productName;
    _this.categoryIds = categoryIds;
    _this.exported = exported;
    _this.exportedDate = exportedDate;
    _this.readonly = readonly;
    _this.prices = prices;
    _this.purchasePrice = purchasePrice;
    _this.regularPrice = regularPrice;
    _this.vendorAllowance = vendorAllowance;
    _this.productSensitivityId = productSensitivityId;
    _this.tierId = tierId;
    _this.weighted = weighted;
    _this.fixedPrice = fixedPrice;
    _this.validationResult = validationResult;
    _this.uploaded = uploaded;
    _this.realImpact = realImpact;
    return _this;
  }

  _createClass(ReleaseItem, [{
    key: "getYdgPrices",
    value: function getYdgPrices() {
      return this.prices;
    }
    /**
     * Returns VA in %.
     */

  }, {
    key: "getVendorAllowancePercent",
    value: function getVendorAllowancePercent() {
      // LOG-5292: Using withoutBackBonus
      return this.vendorAllowance !== null && this.vendorAllowance.withoutBackBonus !== null ? this.vendorAllowance.withoutBackBonus : null;
    }
  }, {
    key: "withMessage",
    value: function withMessage(message) {
      return this.copy('validationResult', this.validationResult.addObjectIfNotPresent(message));
    }
  }, {
    key: "withMessageInOptAndFinalPrices",
    value: function withMessageInOptAndFinalPrices(msg) {
      return this.copy('prices', this.prices.map(function (pr) {
        var optWithConstraints = pr.optimalPriceWithConstraints !== null ? pr.optimalPriceWithConstraints.withMessage(msg) : null;
        var optWithoutConstraints = pr.optimalPriceWithoutConstraints !== null ? pr.optimalPriceWithoutConstraints.withMessage(msg) : null;
        var finalPrice = pr.finalPrice !== null ? pr.finalPrice.withMessage(msg) : null;
        return pr.copyMulti({
          optimalPriceWithConstraints: optWithConstraints,
          optimalPriceWithoutConstraints: optWithoutConstraints,
          finalPrice: finalPrice
        });
      }));
    }
    /**
     * Returns copy of this release item with updated prices for given price zone id.
     * @param priceZoneId
     * @param updater function that returns updated prices for given price zone
     */

  }, {
    key: "withUpdatedPrices",
    value: function withUpdatedPrices(priceZoneId, updater) {
      var updatedPrices = this.prices.map(function (pzPrices) {
        return pzPrices.priceZoneId === priceZoneId ? updater(pzPrices) : pzPrices;
      });
      return this.copy('prices', updatedPrices);
    }
    /**
     * Returns copy of this release item with updated final price. Only currently existing final price will be updated.
     * @param priceZoneId
     * @param updater
     */

  }, {
    key: "withUpdatedFinalPrice",
    value: function withUpdatedFinalPrice(priceZoneId, updater) {
      return this.withUpdatedPrices(priceZoneId, function (priceZonePrices) {
        if (priceZonePrices.finalPrice !== null) {
          return priceZonePrices.copy('finalPrice', updater(priceZonePrices.finalPrice));
        } else {
          return priceZonePrices;
        }
      });
    }
    /**
     * Returns final price for given price zone id, or null if not found.
     * @param priceZoneId
     */

  }, {
    key: "getFinalPrice",
    value: function getFinalPrice(priceZoneId) {
      var prices = utils_1.Utils.undefinedToNull(this.prices.find(function (pzPrices) {
        return pzPrices.priceZoneId === priceZoneId;
      }));
      return prices !== null ? prices.finalPrice : null;
    }
    /**
     * @param priceZoneId The zone of which prices should be retrieved.
     * @returns prices related to given price zone
     * @throws error if prices related to given price zone does not exist.
     */

  }, {
    key: "requireZonePrices",
    value: function requireZonePrices(priceZoneId) {
      var zonePrices = this.prices.find(function (p) {
        return p.priceZoneId === priceZoneId;
      });

      if (!zonePrices) {
        throw new Error("Item with id ".concat(this.id, " does not contain prices related to zone with id ").concat(priceZoneId, "!"));
      }

      return zonePrices;
    }
    /**
     * Updates exported flag on this release item based on new final price that is already part of this release item.
     * @returns updated item.
     */

  }, {
    key: "withExportedForNewPrice",
    value: function withExportedForNewPrice() {
      var exported = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.prices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var pzPrices = _step.value;
          var finalPriceValue = pzPrices.finalPrice !== null ? pzPrices.finalPrice.getPresentedValue() : null;
          var regularPriceValue = pzPrices.regularPrice !== null ? pzPrices.regularPrice.getPresentedValue() : null;
          exported = finalPriceValue !== null && !this.readonly && (regularPriceValue === null || !finalPriceValue.equals(regularPriceValue));

          if (exported) {
            // at least one final price differs from corresponding regular price within a price zone
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return this.copy('exported', exported);
    }
  }]);

  return ReleaseItem;
}(AbstractReleaseItem_1.AbstractReleaseItem);

exports.ReleaseItem = ReleaseItem;

ReleaseItem.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ReleaseItem.name);
  return {
    id: builder.id('id'),
    releaseId: builder.str('releaseId'),
    productId: builder.str('productId'),
    productExternalId: builder.str('productExternalId'),
    productName: builder.str('productName'),
    categoryIds: builder.listOf(builder.id('categoryIds')),
    exported: builder.bool('exported'),
    exportedDate: builder.opt(builder.date('exportedDate', DateParser_1.DateParser.ISO_PATTERN)),
    readonly: builder.bool('readonly'),
    prices: builder.listOf(builder.obj('prices', PriceZoneReleasePrices_1.PriceZoneReleasePrices.schema, function (mat) {
      return PriceZoneReleasePrices_1.PriceZoneReleasePrices.fromDataDict(mat);
    })),
    purchasePrice: builder.opt(builder.obj('purchasePrice', ProductPurchasePrice_1.ProductPurchasePrice.schema, function (mat) {
      return ProductPurchasePrice_1.ProductPurchasePrice.fromDataDict(mat);
    })),
    regularPrice: builder.opt(builder.obj('regularPrice', RegularProductPrice_1.RegularProductPrice.productPriceSchema, function (mat) {
      return new RegularProductPrice_1.RegularProductPrice(mat.value, mat.valueRounded, mat.vatRate);
    })),
    vendorAllowance: builder.opt(builder.obj('vendorAllowance', VendorAllowanceBonus_1.VendorAllowanceBonus.schema, function (mat) {
      return VendorAllowanceBonus_1.VendorAllowanceBonus.fromDataDict(mat);
    })),
    productSensitivityId: builder.opt(builder.str('productSensitivityId')),
    tierId: builder.opt(builder.str('tierId')),
    weighted: builder.bool('weighted'),
    fixedPrice: builder.bool('fixedPrice'),
    validationResult: builder.obj('validationResult', ValidationResult_1.ValidationResult.schema, function (mat) {
      return new ValidationResult_1.ValidationResult(mat.resultObjects);
    }),
    uploaded: builder.bool('uploaded'),
    realImpact: builder.opt(builder.obj('realImpact', RealImpactValue_1.RealImpactValue.schema, RealImpactValue_1.RealImpactValue.ctor))
  };
}();